module.exports = __webpack_public_path__ + "static/puma-3-fe9196e18324a8836f2f07c101b24f2a.jpg";